import axios from 'axios';
import { handleResponse } from '../../../utils/apiHandler';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

function getAuthHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
}

export function fetchTeamSummary() {
  return axios.get(`${API_URL}/api/employee/manager/team-summary/`, { headers: getAuthHeaders() });
}

export function approveOrRejectLeaveRequest(leaveId, status) {
  return axios.put(
    `${API_URL}/api/employee/leaves/${leaveId}/approve-reject/`,
    { status_of_leave: status },
    { headers: getAuthHeaders() }
  );
}

export function fetchTeamLeaveRequests(statuses = ['Pending'], page = 1, limit = 10, searchTerms = []) {
  let params = {
    page,
    limit
  };
  
  if (Array.isArray(statuses) && statuses.length > 0) {
    params.status_of_leave = statuses.join(',');
  } else if (typeof statuses === 'string' && statuses) {
    params.status_of_leave = statuses;
  }
  
  if (searchTerms) {
    params.search = searchTerms.join(',');
  }
  
  return axios.get(`${API_URL}/api/employee/manager/team-leaves/`, {
    headers: getAuthHeaders(),
    params,
  });
}

export async function fetchLeaveCollections() {
  const res = await fetch(`${API_URL}/api/employee/collection/?type=leave_types,leave_day_type,holidays`);
  return handleResponse(res, 'Failed to fetch leave collections');
}

export async function postLeaveRequest(payload) {
  const res = await fetch(`${API_URL}/api/employee/leaves/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return handleResponse(res, 'Failed to apply leave');
}
